// These functions must only set state values.
// They all generally do the same thing - only commit a state when the value is going to change.
// They are referenced from various actions so they are all gathered here.

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Title…

export function setTitle(sm, title) {
    if (sm.state['title'] !== title) { sm.commit('title', title) };
}

export function clearTitle(sm) {
    if (sm.state['title'] !== null) { sm.commit('title', null) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Modal…
export function setModal(sm, modeCode) {
    if (sm.state['modal'] !== modeCode) { sm.commit('modal', modeCode) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Initializing…
export function setInitializing(sm, initializing) {
    if (sm.state['initializing'] !== initializing) { sm.commit('initializing', initializing) }
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Initializing failed…
export function setInitializingFailed(sm, initializingFailed) {
    if (sm.state['initializingFailed'] !== initializingFailed) { sm.commit('initializingFailed', initializingFailed) }
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Booting…
export function setBooting(sm, booting) {
    if (sm.state['booting'] !== booting) { sm.commit('booting', booting) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Boot Progress…
export function setBootProgress(sm, progressPortion) {
    if (sm.state['bootProgress'] !== progressPortion) { sm.commit('bootProgress', progressPortion) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Everything loaded…
export function setEverythingLoaded(sm, everythingLoaded) {
    if (sm.state['everythingLoaded'] !== everythingLoaded) { sm.commit('everythingLoaded', everythingLoaded) }
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Nav…
export function setNavLoaded(sm, navLoaded) {
    if (sm.state['navLoaded'] !== navLoaded) { sm.commit('navLoaded', navLoaded) }
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Experience Markers…
export function setExperienceMarkersLoaded(sm, loaded) {
    if (sm.state['experienceMarkersLoaded'] !== loaded) { sm.commit('experienceMarkersLoaded', loaded) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Loading Items…
export function addLoadingItem(sm, item) {
    let loadingItems = [].concat(sm.state['loadingItems']);
    const loadingItemIds = loadingItems.map((item) => { return item.id });
    if (!loadingItemIds.includes(item.id)) {
        loadingItems.push(item);
        sm.commit('loadingItems', loadingItems);
    }
}

export function removeLoadingItem(sm, item) {
    let loadingItems = [].concat(sm.state['loadingItems']);
    const loadingItemIds = loadingItems.map((item) => { return item.id });
    if (loadingItemIds.includes(item.id)) {
        loadingItems = loadingItems.filter((existingItem) => { return existingItem.id !== item.id });
        sm.commit('loadingItems', loadingItems);
    }
}


// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Nav…

export function setNavOpen(sm, open) {
    if (sm.state['navOpen'] !== open) { sm.commit('navOpen', open) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Nav Option…

export function setNavOption(sm, navOption) {
    if (sm.state['navOption'] !== navOption) { sm.commit('navOption', navOption) };
}

export function clearNavOption(sm) {
    if (sm.state['navOption'] !== null) { sm.commit('navOption', null) };
}

export function setPrevNavOption(sm, navOption) {
    if (sm.state['prevNavOption'] !== navOption) { sm.commit('prevNavOption', navOption) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Map Filter…

export function setMapFilter(sm, mapFilter) {
    if (sm.state['mapFilter'] !== mapFilter) { sm.commit('mapFilter', mapFilter) };
}

export function clearMapFilter(sm) {
    if (sm.state['mapFilter'] !== null) { sm.commit('mapFilter', null) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Aux…

export function setAuxMinimized(sm, minimized) {
    if (sm.state['auxMinimized'] !== minimized) { sm.commit('auxMinimized', minimized) };
}

export function setAuxResourceUrl(sm, url) {
    if (sm.state['auxResourceUrl'] !== url) { sm.commit('auxResourceUrl', url) };
}

export function clearAuxResourceUrl(sm) {
    if (sm.state['auxResourceUrl'] !== null) { sm.commit('auxResourceUrl', null) };
}

export function setAuxResourceName(sm, name) {
    if (sm.state['auxResourceName'] !== name) { sm.commit('auxResourceName', name) };
}

export function clearAuxResourceName(sm) {
    if (sm.state['auxResourceName'] !== null) { sm.commit('auxResourceName', null) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Experience Marker…

export function setExperienceMarker(sm, experienceMarker) {
    if (sm.state['experienceMarker'] !== experienceMarker) { sm.commit('experienceMarker', experienceMarker) };
}

export function clearExperienceMarker(sm) {
    if (sm.state['experienceMarker'] !== null) { sm.commit('experienceMarker', null) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Map Bounds…

export function setMapBounds(sm, mapBounds) {
    if (sm.state['mapBounds'] !== mapBounds) { sm.commit('mapBounds', mapBounds) };
}

export function clearMapBounds(sm) {
    if (sm.state['mapBounds'] !== null) { sm.commit('mapBounds', null) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Geo Data…

export function setGeoData(sm, geoData) {
    if (sm.state['geoData'] !== geoData) { sm.commit('geoData', geoData) }
}

export function clearGeoData(sm) {
    if (sm.state['geoData'] !== null) { sm.commit('geoData', null) }
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Render Map Bounds…

export function setRenderMapBounds(sm, render) {
    if (sm.state['renderMapBounds'] !== render) { sm.commit('renderMapBounds', render) };
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Footer…

export function setFooterOpen(sm, open) {
    if (sm.state['footerOpen'] !== open) { sm.commit('footerOpen', open) };
}
